import TablePage from '@/found/components/table_page';
import Form from './form';

export default {
  extends: TablePage,
  components: { Form },
  data() {
    return {
      requestType: 'POST',
    };
  },
  mounted() {
    this.getConfigList('page_list');
  },
  methods: {
    // 弹框操作
    modalClick({ val, row }) {
      if (val.code === 'detail') {
        this.propsObjInData.id = row.id;
        this.modalConfig.title = '明细';
        this.openFull();
      }
    },
  },
};
